import { defineComponent as o, openBlock as a, createBlock as t, unref as l, mergeProps as p, withCtx as i, createElementVNode as m } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconSpeakerInSquareFilled",
  __name: "IconSpeakerInSquareFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const n = r;
    return (u, e) => (a(), t(l(d), p(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M18 3.25A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h12m-5.5 5.476a.5.5 0 0 0-.799-.4l-2.735 2.036a.5.5 0 0 1-.298.1H7.5a.5.5 0 0 0-.5.5v2.035a.5.5 0 0 0 .5.5h1.168a.5.5 0 0 1 .298.1l2.735 2.038a.5.5 0 0 0 .799-.402V8.726m3.773.138a.75.75 0 0 0-1.05 1.073 2.85 2.85 0 0 1 .86 2.043 2.85 2.85 0 0 1-.86 2.043.75.75 0 0 0 1.05 1.073 4.35 4.35 0 0 0 1.31-3.117 4.35 4.35 0 0 0-1.31-3.115",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
